import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import ChainedBackend from 'i18next-chained-backend'
import Backend from 'i18next-http-backend'
import LocalStorageBackend, { LocalStorageBackendOptions } from 'i18next-localstorage-backend'

import { langWithoutRegion } from '~/utils/lang-without-region'

// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

const loadPathWithoutRegion = (lngs: string[], namespaces: string[]) =>
  `/locales/${lngs.map(langWithoutRegion).join('-')}/${namespaces.join('-')}.json`

const syncDocumentLanguage = (language: string) => {
  document.documentElement.setAttribute('lang', langWithoutRegion(language))
}

void i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(ChainedBackend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    // Match /locales/{base}/… files and LocalStorage `versions` keys (e.g. en-GB → en).
    load: 'languageOnly',
    partialBundledLanguages: true,
    ns: ['translation'],
    defaultNS: 'translation',
    debug: import.meta.env.DEV,
    backend: {
      backends: [LocalStorageBackend, Backend],
      backendOptions: [
        {
          expirationTime: 10 * 365 * 24 * 60 * 60 * 1000, // 10 years
          versions: { de: '33', en: '33', ru: '34', tr: '33', uk: '34' },
        } as LocalStorageBackendOptions,
        {
          loadPath: loadPathWithoutRegion,
        },
      ],
    },
  })

i18n.on('initialized', () => syncDocumentLanguage(i18n.resolvedLanguage ?? i18n.language))
i18n.on('languageChanged', syncDocumentLanguage)

export default i18n
